import { FETCH_DATA_EVENT_PROP_NAME, FETCH_DATA_EVENT_NAME, FetchDataEventProp } from './constants';

/**
 * @return {Promise<any>}
 */
const FetchDataEventPanelAsync = () => import('./FetchDataEventPanel.vue');

/**
 * factory returns fetchDataEventMixin
 *
 * @param {{ methodName: string }} options - mixin options
 * @return {import('./useFetchDataEventMixin').IFetchDataEventMixin}
 */
export const useFetchDataEventMixin = (options = { methodName: '' }) => ({
    meta: {
        panels: [FetchDataEventPanelAsync]
    },
    data: () => ({
        descriptor: {
            props: {
                [FETCH_DATA_EVENT_PROP_NAME]: { ...FetchDataEventProp }
            },
            events: {
                [FETCH_DATA_EVENT_NAME]: {
                    listen: FETCH_DATA_EVENT_PROP_NAME
                }
            }
        }
    }),
    subscribe: [
        {
            event: FETCH_DATA_EVENT_NAME,
            handler() {
                this[options.methodName]?.();
            }
        }
    ]
});
